import {
  Article,
  ArticleAction,
  ArticleImage,
  ArticleSubtitle,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import { Button } from "@babackapp/customer-ui/components/button";
import { getLineItemDisplay } from "@babackapp/return-widget-components/utils/line-item-display";
import type { DraftLineItem, OrderLineItem } from "@babackapp/return-widget-components/types";
import { Trash2Icon } from "lucide-react";

type Props = {
  item: DraftLineItem;
  orderLineItems: OrderLineItem[];
  onRemove: () => void;
};

export function SummaryLineItem({ item, orderLineItems, onRemove }: Props) {
  const { title, subtitle, image } = getLineItemDisplay(orderLineItems, item.lineItemId);

  return (
    <Article>
      <ArticleImage src={image ?? undefined} layoutId={`img-${item.lineItemId}`} />
      <ArticleTitle>{title}</ArticleTitle>
      {subtitle ? (
        <ArticleSubtitle>{subtitle} — ×{item.quantity}</ArticleSubtitle>
      ) : (
        <ArticleSubtitle>×{item.quantity}</ArticleSubtitle>
      )}
      <ArticleAction autoHide={false}>
        <Button variant="outline" size="icon-sm" onClick={onRemove}>
          <Trash2Icon />
        </Button>
      </ArticleAction>
    </Article>
  );
}
